import { Col, Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { extrasVM } from '../Extras.page';
import { BasicMenu } from '@client/new/components/BasicMenu/BasicMenu';
import { toExtrasMenuItems } from '../viewModel/extras.mappers';

export const ExtrasEmptyState = () => {
  const vm = extrasVM.useValue();
  const shouldShowEmptyState = vm.isExtrasEmpty && vm.formType !== 'ContentTab';

  if (!shouldShowEmptyState) return null;

  return (
    <Row>
      <Col center gap="l">
        <Typography variant="headline" size="medium">
          Add your content
        </Typography>
        <Typography variant="body" size="large" fontWeight="normal">
          Add links, PDF or Slides to your content - anything else you'd like
          your users aware of.
        </Typography>
        <BasicMenu
          testId="extras-create-menu"
          title="New"
          items={toExtrasMenuItems(vm.dispatch)}
        />
      </Col>
    </Row>
  );
};
